import type { JSX } from "preact";

/**
 * Line icons for the Step 2 load pickers. Stroke-based, currentColor, 24x24 —
 * matching the DocIcon/PanelIcon style already used in Step3Bill so the whole
 * funnel reads as one icon family.
 */
type IconProps = JSX.SVGAttributes<SVGSVGElement>;

const base = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": 1.8,
  "stroke-linecap": "round" as const,
  "stroke-linejoin": "round" as const,
  "aria-hidden": true,
};

export const FlameIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <path d="M12 3c1 3 4 4.5 4 8a4 4 0 0 1-8 0c0-1.3.5-2.3 1.2-3.2C9.9 6.7 11 5.5 12 3z" />
  </svg>
);

export const PropaneIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <rect x="7" y="7" width="10" height="14" rx="3" />
    <path d="M10 7V5a2 2 0 0 1 4 0v2M12 3v2" />
  </svg>
);

export const OilIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <path d="M12 3c3.5 4 5.5 6.6 5.5 9.5a5.5 5.5 0 0 1-11 0C6.5 9.6 8.5 7 12 3z" />
  </svg>
);

export const BoltIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <path d="M13 2 4 14h7l-1 8 9-12h-7z" />
  </svg>
);

export const DotsIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <circle cx="5" cy="12" r="1.2" />
    <circle cx="12" cy="12" r="1.2" />
    <circle cx="19" cy="12" r="1.2" />
  </svg>
);

export const NoneIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M6 6l12 12" />
  </svg>
);

export const SnowflakeIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <path d="M12 2v20M4.2 7l15.6 10M19.8 7 4.2 17" />
    <path d="M12 6l-2.5-2.5M12 6l2.5-2.5M12 18l-2.5 2.5M12 18l2.5 2.5" />
  </svg>
);

export const WellPumpIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <path d="M12 3c3.2 3.7 5 6 5 8.7a5 5 0 0 1-10 0C7 9 8.8 6.7 12 3z" />
  </svg>
);

export const RangeIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <rect x="4" y="4" width="16" height="16" rx="2" />
    <circle cx="9" cy="9" r="1.6" />
    <circle cx="15" cy="9" r="1.6" />
    <path d="M8 15h8" />
  </svg>
);

export const DryerIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <rect x="4" y="3" width="16" height="18" rx="2" />
    <circle cx="12" cy="13" r="4.5" />
    <path d="M8 6h.01M11 6h.01" />
  </svg>
);

export const WaterHeaterIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <rect x="6" y="3" width="12" height="18" rx="4" />
    <path d="M12 8v6" />
    <circle cx="12" cy="16" r="1" />
  </svg>
);

export const EvChargerIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <rect x="6" y="3" width="12" height="18" rx="2" />
    <path d="M13 7l-3 4h3l-3 4" />
  </svg>
);

export const HotTubIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <path d="M3 12h18M4 12v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-6" />
    <path d="M8 12V7a2 2 0 0 1 4 0" />
    <path d="M15 5c1 .8 1 1.7 0 2.5" />
  </svg>
);

export const PoolPumpIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <path d="M3 8c1.5 1.2 3 1.2 4.5 0S10.5 6.8 12 8s3 1.2 4.5 0S19.5 6.8 21 8" />
    <path d="M3 13c1.5 1.2 3 1.2 4.5 0S10.5 11.8 12 13s3 1.2 4.5 0S19.5 11.8 21 13" />
    <path d="M3 18c1.5 1.2 3 1.2 4.5 0S10.5 16.8 12 18s3 1.2 4.5 0S19.5 16.8 21 18" />
  </svg>
);

export const GasMeterIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="10" r="7" />
    <path d="M12 6v4l2 2M8 21h8" />
  </svg>
);
